import { Zap, Instagram, Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="border-t border-border bg-[#0A0A0A] text-white mt-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 font-display font-black text-2xl">
            <span className="grid place-items-center w-9 h-9 rounded-md bg-primary text-primary-foreground">
              <Zap className="w-5 h-5" />
            </span>
            Dirt Or Road
          </div>
          <p className="mt-4 text-white/60 max-w-sm leading-relaxed">
            Affordable scooter & moped hire for food delivery drivers across North West London. Hire, services & repairs — ride more, earn more, worry less.
          </p>
          <div className="mt-6 flex gap-3">
            <a href="https://instagram.com/dirtorroadhire" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="grid place-items-center w-10 h-10 rounded-lg bg-white/10 hover:bg-primary transition-colors">
              <Instagram className="w-5 h-5" />
            </a>
            <a href="tel:07498253046" data-testid="footer-phone-icon" className="grid place-items-center w-10 h-10 rounded-lg bg-white/10 hover:bg-primary transition-colors">
              <Phone className="w-5 h-5" />
            </a>
            <a href="mailto:dirtorroad@outlook.com" data-testid="footer-email-icon" className="grid place-items-center w-10 h-10 rounded-lg bg-white/10 hover:bg-primary transition-colors">
              <Mail className="w-5 h-5" />
            </a>
          </div>
        </div>
        <div>
          <p className="label-caps text-white/40 mb-4">Explore</p>
          <ul className="space-y-3 text-white/70">
            <li><Link to="/bikes" className="hover:text-primary transition-colors">Browse Bikes</Link></li>
            <li><Link to="/register" className="hover:text-primary transition-colors">Become a Rider</Link></li>
          </ul>
        </div>
        <div>
          <p className="label-caps text-white/40 mb-4">Get in touch</p>
          <ul className="space-y-3 text-white/70">
            <li><a href="mailto:dirtorroad@outlook.com" data-testid="footer-email" className="hover:text-primary transition-colors break-all">dirtorroad@outlook.com</a></li>
            <li><a href="tel:07498253046" data-testid="footer-phone" className="hover:text-primary transition-colors">07498 253 046</a></li>
            <li><a href="https://instagram.com/dirtorroadhire" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">@dirtorroadhire</a></li>
            <li>North West London</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-white/40 text-sm">
        © {new Date().getFullYear()} Dirt Or Road Ltd. All rights reserved. · North West London
      </div>
    </footer>
  );
}
